import React from 'react';
import { LayoutMode } from '../types';
import { layoutOptions } from '../constants';
import SearchInput from '../../../component/SearchInput';

interface DashboardResultsToolbarProps {
    searchTerm: string;
    setSearchTerm: (term: string) => void;
    totalInstances: number;
    filteredInstances: number;
    layoutMode: LayoutMode;
    setLayoutMode: (mode: LayoutMode) => void;
}

const DashboardResultsToolbar: React.FC<DashboardResultsToolbarProps> = ({
    searchTerm,
    setSearchTerm,
    totalInstances,
    filteredInstances,
    layoutMode,
    setLayoutMode
}) => {
    return (
        <div className="estate-results-toolbar d-flex align-items-center mb-3">
            <SearchInput
                className="estate-search"
                placeholder="Search instances..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClear={() => setSearchTerm('')}
            />
            <span className="instance-count-display">
                <span className="count-numbers">{filteredInstances}/{totalInstances}</span>
                <span className="count-label">Instances</span>
            </span>
            <div className="btn-group layout-mode-toggle ms-auto" role="group" aria-label="Layout Mode Toggle">
                {layoutOptions.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        className={`btn btn-sm btn-outline-secondary ${layoutMode === option.value ? 'active' : ''}`}
                        onClick={() => setLayoutMode(option.value as LayoutMode)}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={option.label}
                    >
                        <i className={option.icon} aria-hidden="true"></i>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default DashboardResultsToolbar;
